/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { Iceutility } from '../iceutility';
import { IIceEntity, IceEntity } from "../../models/core/IceEntity";
import { BaseService } from "../../services/baseservice";
import { AlertService } from "../../services/alert/alert.service";
import { LoginService } from '../../login/login.service';

import { provider_index } from "../../models/domain/provider_index";
import { payer_index } from "../../models/domain/payer_index";
import { patient } from "../../models/domain/patient";
import { patientindex } from "../../models/domain/patientindex";
import { contact } from "../../models/common/contact";
import { entity } from "../../models/common/entity";
import { address } from "../../models/common/address";
import { identification } from "../../models/common/identification";
import { provider } from "../../models/domain/provider";
import { pharmacy } from "../../models/domain/pharmacy";
import { pharmacyindex } from "../../models/domain/pharmacyindex";
import { logmessage } from "../../models/system/logmessage";
import { LogReport } from "../../models/system/LogReport";
import { message } from "../../models/messages/message";
import { alert } from "../../models/system/alert";
import { messagereference } from "../../models/messages/messagereference";
import { calendar } from "../../models/schedule/calendar";
import { appointment } from "../../models/schedule/appointment";
import { appointmentindex } from "../../models/schedule/appointmentindex";
import { appointmentreference } from "../../models/schedule/appointmentreference";
import { day } from "../../models/schedule/day";
import { slot } from "../../models/schedule/slot";
import { task } from "../../models/schedule/task";
import { taskindex } from "../../models/schedule/taskindex";
import { taskreference } from "../../models/schedule/taskreference";
import { report } from "../../models/reports/report";
import { reportindex } from "../../models/reports/reportindex";
import { reporttemplate } from "../../models/reports/reporttemplate";
import { reportfilter } from "../../models/reports/subs/reportfilter";
import { reportdata } from "../../models/reports/reportdata";
import { antenatalattendancestat } from '../../models/stats/antenatalattendancestat';
import { labordeliverystat } from '../../models/stats/labordeliverystat';
import { patientstat } from '../../models/stats/patientstat';
import { user } from '../../models/common/user'
import { consentreference } from "../../models/domain/consentreference";
import { diagnosis } from "../../models/ehr/diagnosis";
import { medication } from "../../models/ehr/medication";
import { allergies } from '../../models/ehr/allergies';
import { externaldata } from '../../models/ehr/externaldata';
import { IceTypes } from "../../models/icetypes";
import { orderentryindex } from 'projects/icemedx-lib/src/models/ehr/orderentryindex';
import { connectionparameters } from 'projects/icemedx-lib/src/models/messages/connectionparameters';
import { observation } from 'projects/icemedx-lib/src/models/ehr/subs/observation';
import { subtypereference } from 'projects/icemedx-lib/src/models/ehr/subs/subtypereference';
import { subtypeitem } from 'projects/icemedx-lib/src/models/ehr/subs/subtypeitem';
import { basecodereference } from 'projects/icemedx-lib/src/models/ehr/subs/basecodereference';
import { managementguideline } from 'projects/icemedx-lib/src/models/ehr/subs/managementguideline';
import { procedure } from 'projects/icemedx-lib/src/models/ehr/subs/procedure';
import { diagnosisreference } from 'projects/icemedx-lib/src/models/ehr/subs/diagnosisreference';
import { managementguidelineindex } from 'projects/icemedx-lib/src/models/ehr/subs/managementguidelineindex';
import { encounterindex } from 'projects/icemedx-lib/src/models/ehr/encounterindex';
import { provider_reference } from '../../models/domain/provider_reference';
import { vendorindex } from '../../models/domain/vendorindex';
import { payerproviderreferenceidentification } from '../../models/messages/payerproviderreferenceidentification';
import { vendor } from '../../models/domain/vendor';
import { transtype } from '../../models/domain/transtype';
import { transtypereference } from '../../models/messages/transtypereference';
import { basecode } from '../../models/ehr/subs/basecode';
import { assetjournal } from '../../models/accounting/assetjournal';
import { otheritemsjournal } from '../../models/accounting/otheritemsjournal';
import { generalledger } from '../../models/accounting/generalledger';
import { payment } from '../../models/accounting/payment';
import { incomerevenuejournal } from '../../models/accounting/incomerevenuejournal';
import { liabilityjournal } from '../../models/accounting/liabilityjournal';
import { servicepaymentreference } from '../../models/accounting/servicepaymentreference';
import { servicereference } from '../../models/ehr/subs/servicereference';
import { capitalequityjournal } from '../../models/accounting/capitalequityjournal';
import { expensejournal } from '../../models/accounting/expensejournal';
import { taxrate } from '../../models/accounting/taxrate';
import { taxauthority } from '../../models/accounting/taxauthority';
import { taxrateauthority } from '../../models/accounting/taxrateauthority';
import { toothinformation } from '../../models/accounting/medservice/toothinformation';
import { testresults } from '../../models/accounting/medservice/testresults';
import { superbillchargesreference } from '../../models/accounting/medservice/superbillchargesreference';
import { superbillchargesindex } from '../../models/accounting/medservice/superbillchargesindex';
import { superbillcharges } from '../../models/accounting/medservice/superbillcharges';
import { medicalservicereference } from '../../models/accounting/medservice/medicalservicereference';
import { homeoxygen } from '../../models/accounting/medservice/homeoxygen';
import { referenceimmunization } from '../../models/accounting/medservice/referenceimmunization';
import { immunization } from '../../models/accounting/medservice/immunization';
import { formidentification } from '../../models/accounting/medservice/formidentification';
import { formdocumentation } from '../../models/accounting/medservice/formdocument';
import { fileinformation } from '../../models/accounting/medservice/fileinformation';
import { dmerc } from '../../models/accounting/medservice/dmerc';
import { dental } from '../../models/accounting/medservice/dental';
import { anesthesia } from '../../models/accounting/medservice/anesthesia';
import { adjudicationdetail } from '../../models/accounting/medservice/adjudicationdetail';
import { adjudication } from '../../models/accounting/medservice/adjudication';
import { servicedate } from '../../models/ehr/subs/servicedate';
import { referenceidentification } from '../../models/ehr/subs/referenceidentification';
import { medicalservice } from '../../models/accounting/medservice/medicalservice';
import { payer } from '../../models/domain/payer';
import { licenseobject, feeobject, limitobject } from '../../models/domain/license';
import { subscriptionobject } from '../../models/domain/subscription';
import { orderobject } from '../../models/domain/order';
import { orderdetailobject } from '../../models/domain/orderdetail';
import { paymentrequest } from '../../models/domain/paymentrequest';
import { otheritems } from '../../models/otheritems/otheritems';
import { otheritemsreceiving } from '../../models/otheritems/otheritemsreceiving';
import { otheritemsindex } from '../../models/otheritems/otheritemsindex';
import { encounterprogressnotes } from '../../models/ehr/encounterprogressnotes';
import { encounterprogressnotesreference } from '../../models/ehr/subs/encounterprogressnotesreference';
import { DrugsResponse, Drug, RXNCONSO, RXNSAT, DrugsSideEffectsResponse, DrugSideEffect, DrugIngredient, DrugComposition, DrugIngredientsResponse } from '../../models/ehr/subs/drugresponse';
import { purchasedelivery } from '../../models/accounting/medservice/purchasedelivery';
import { purchaseorder } from '../../models/accounting/medservice/purchaseorder';
import { purchaseindex } from '../../models/accounting/medservice/purchaseindex';
import { subscriber } from '../../models/domain/subscriber';
import { subscriberindex } from '../../models/domain/subscriberindex';
import { superbill } from '../../models/accounting/superbill';
import { superbillindex } from '../../models/accounting/superbillindex';
import { viralstat } from '../../models/stats/viralstat';
import { accountingsummary } from '../../models/stats/accountingsummary';
import {
  alertsummary,
  limitsummary,
  allergy_interaction,
  cpt_contraindication, cpt_interaction, cpt_required, cpt_synonym,
  diag_contraindication, diag_interaction, diag_required, diag_synonym,
  ndc_contraindication, ndc_interaction, ndc_required, ndc_synonym,
  resultsummary, surveysummary, guidelinesummary, limitandsurveyresult, coderesult, resultinformation, cpt_addon, ndc_addon, cpt_includes, ndc_includes, diag_includes, cpt_excludes1, ndc_excludes1, diag_excludes1, cpt_excludes2, ndc_excludes2, diag_excludes2, cpt_notallowed, ndc_notallowed, cpt_allowed, ndc_allowed, cpt_notapplicable, ndc_notapplicable, cpt_muepolicy2, ndc_muepolicy2, cpt_mueclinical3, ndc_mueclinical3, cpt_consider, ndc_consider, diag_consider
} from '../cds/guidelinesummary';
import { dependentreference } from '../../models/ehr/subs/dependentreference';
import { coverage } from '../../models/ehr/subs/coverage';
import { reviewer } from '../../models/ehr/subs/reviewer';
import { lodgemembershipsummary } from '../../models/stats/lodgemembshipsummary';
import { SS } from '../../models/system/ssmessage';
import { payto } from '../../models/accounting/payto';
import { purchaseorderservice } from '../../models/accounting/medservice/purchaseorderservice';
import { rptsection } from '../../models/reports/subs/rptsection';
import { rptobject } from '../../models/reports/subs/rptobject';
import { medicationactivity } from '../../models/ehr/subs/medicationactivity';
import { providerstat } from '../../models/stats/providerstat';
import { pharmacystat } from '../../models/stats/pharmacystat';
import { paytoindex } from '../../models/accounting/paytoindex';
import { benefitinformation } from '../../models/ehr/subs/benefitinformation';
import { requestvalidation } from '../../models/ehr/subs/requestvalidation';
import { option } from '../../models/domain/option';
import { medicalserviceindex } from '../../models/accounting/medservice/medicalserviceindex';
import { accountingperiodindex } from '../../models/accounting/accountingperoidindex';
import { accountingperiod } from '../../models/accounting/accountingperiod';
import { encounter } from '../../models/ehr/encounter';
import { externaldatareference } from '../../models/ehr/subs/externaldatareference';
import { claim } from '../../models/accounting/claim/claim';
import { claimindex } from '../../models/accounting/claim/claimindex';
import { claimbucket } from '../../models/accounting/claim/claimbucket';
import { claimbucketindex } from '../../models/accounting/claim/claimbucketindex';
import { claimcontract } from '../../models/accounting/claim/claimcontract';
import { claimhomehealthcareplan } from '../../models/accounting/claim/claimhomehealthcareplan';
import { claimmedicareoutpatientadjudication } from '../../models/accounting/claim/claimmedicareoutpatientadjudication';
import { claimnote } from '../../models/accounting/claim/claimnote';
import { claimrepriced } from '../../models/accounting/claim/claimrepriced';
import { claimspinal } from '../../models/accounting/claim/claimspinal';
import { claimsupplementalinformation } from '../../models/accounting/claim/claimsupplementalinformation';
import { claimambulance } from '../../models/accounting/claim/claimambulance';
import { condition } from '../../models/ehr/subs/condition';
import { amount } from '../../models/ehr/subs/amount';
import { subscriberreference } from '../../models/ehr/subs/subscriberreference';
import { referralreference } from '../../models/ehr/subs/referralreference';
import { claimhealthcaredelivery } from '../../models/accounting/claim/claimhealthcaredelivery';
import { previouscertification } from '../../models/ehr/subs/previouscertification';
import { relatedcause } from '../../models/ehr/subs/relatedcause';
import { addressreference } from '../../models/common/addressreference';
import { oxygenequipmenttype } from '../../models/ehr/subs/oxygenequipmenttype';
import { oxygentestresults } from '../../models/ehr/subs/oxygentestresults';
import { benefitscoordination } from '../../models/ehr/subs/benefitscoordination';
import { referralindex } from '../../models/ehr/referralindex';
import { referral } from '../../models/ehr/referral';
import { encounterstat } from '../../models/stats/encounterstat';
import { appointmentstat } from '../../models/stats/appointmentstat';
import { clinicaldaysheetstat } from '../../models/stats/clinicaldaysheetstat';
import { notebookitem } from '../../models/customforms/subs/notebookitem';
import { notebookss } from '../../models/customforms/subs/notebookss';
import { notebookpage } from '../../models/customforms/notebookpage';
import { notebookpageindex } from '../../models/customforms/notebookpageindex';
import { notebookpagetotype } from '../../models/customforms/notebookpagetotype';

@Injectable()
export class XmlparseService extends BaseService {
  private escaped_one_to_xml_special_map = {
    '&amp;': '&',
    '&quot;': '"',
    '&lt;': '<',
    '&gt;': '>'
  };

  defaultmodelmap: any = {};

  constructor(private alertService: AlertService,
    private loginService: LoginService) {
    super();

    this.defaultmodelmap["PAYER"] = this.defaultpayer;
    this.defaultmodelmap["ASSET_JOURNAL"] = this.defaultassetjournal;
    this.defaultmodelmap["OTHER_ITEMS_JOURNAL"] = this.defaultassetjournal;
    this.defaultmodelmap["GENEAL_LEDGER"] = this.defaultgeneralledger;
    this.defaultmodelmap["PAYMENT"] = this.defaultpayment;
    this.defaultmodelmap["INCOME_REVENUE_JOURNAL"] = this.defaultincomerevenuejournal;
    this.defaultmodelmap["SERVICE_REFERENCE"] = this.defaultservicereference;
    this.defaultmodelmap["SERVICE_PAYMENT_REFERENCE"] = this.defaultservicepaymentreference;
    this.defaultmodelmap["LIABILITY_JOURNAL"] = this.defaultliabilityjournal;
    this.defaultmodelmap["EXPENSE_JOURNAL"] = this.defaultexpensejournal;
    this.defaultmodelmap["TAX_RATE"] = this.defaulttaxrate;
    this.defaultmodelmap["TAX_AUTHORITY"] = this.defaulttaxauthority;
    this.defaultmodelmap["TAX_RATE_AUTHORITY"] = this.defaulttaxrateauthority;
    this.defaultmodelmap["TOOTH_INFORMATION"] = this.defaulttoothinformation;
    this.defaultmodelmap["TEST_RESULTS"] = this.defaulttestresults;
    this.defaultmodelmap["SUPERBILL_CHARGES_REFERENCE"] = this.defaultsuperbillchargesreference;
    this.defaultmodelmap["SUPERBILL_CHARGES_INDEX"] = this.defaultsuperbillchargesindex;
    this.defaultmodelmap["SUPERBILL_CHARGES"] = this.defaultsuperbillcharges;
    this.defaultmodelmap["MEDICAL_SERVICE_REFERENCE"] = this.defaultmedicalservicereference;
    this.defaultmodelmap["HOME_OXYGEN"] = this.defaulthomeoxygen;
    this.defaultmodelmap["REFERENCE_IMMUNIZATION"] = this.defaultreferenceimmunization;
    this.defaultmodelmap["IMMUNIZATION"] = this.defaultimmunization;
    this.defaultmodelmap["FORM_IDENTIFICATION"] = this.defaultformidentification;
    this.defaultmodelmap["FORM_DOCUMENTATION"] = this.defaultformdocumentation;
    this.defaultmodelmap["FILE_INFORMATION"] = this.defaultfileinformation;
    this.defaultmodelmap["DMERC"] = this.defaultdmerc;
    this.defaultmodelmap["DENTAL"] = this.defaultdental;
    this.defaultmodelmap["ADJUDICATION_DETAIL"] = this.defaultadjudicationdetail;
    this.defaultmodelmap["ANESTHESIA"] = this.defaultanesthesia;
    this.defaultmodelmap["ADJUDICATION"] = this.defaultadjudication;
    this.defaultmodelmap["SERVICE_DATE"] = this.defaultservicedate;
    this.defaultmodelmap["REFERENCE_IDENTIFICATION"] = this.defaultreferenceidentification;
    this.defaultmodelmap["MEDICAL_SERVICE"] = this.defaultmedicalservice;
    this.defaultmodelmap["LICENSE"] = this.defaultlicense;
    this.defaultmodelmap["FEE"] = this.defaultfee;
    this.defaultmodelmap["LIMIT"] = this.defaultlimit;
    this.defaultmodelmap["SUBSCRIPTION"] = this.defaultsubscription;
    this.defaultmodelmap["ORDER"] = this.defaultorder;
    this.defaultmodelmap["ORDER_DETAIL"] = this.defaultorderdetail;
    this.defaultmodelmap["PAYMENT_REQUEST"] = this.defaultpaymentrequest;
    this.defaultmodelmap["OTHER_ITEMS_RECEIVING"] = this.defaultotheritemsreceiving;
    this.defaultmodelmap["OTHER_ITEMS_INDEX"] = this.defaultotheritemsindex;
    this.defaultmodelmap["OTHER_ITEMS"] = this.defaultotheritems;
    this.defaultmodelmap["ENCOUNTER_PROGRESS_NOTES_REFERENCE"] = this.defaultencounterprogressnotesreference;
    this.defaultmodelmap["ENCOUNTER_PROGRESS_NOTES"] = this.defaultencounterprogressnotes;
    this.defaultmodelmap["DRUGSRESPONSE"] = this.defaultDrugsResponse;
    this.defaultmodelmap["SIDEEFFECTSRESPONSE"] = this.defaultDrugsSideEffectsResponse;
    this.defaultmodelmap["INGREDIENTSRESPONSE"] = this.defaultDrugIngredientsResponse;
    this.defaultmodelmap["SIDEEFFECT"] = this.defaultDrugSideEffect;
    this.defaultmodelmap["INGREDIENT"] = this.defaultDrugIngredient;
    this.defaultmodelmap["DRUGCOMPOSITION"] = this.defaultDrugComposition;
    this.defaultmodelmap["DRUG"] = this.defaultDrug;
    this.defaultmodelmap["RXNCONSO"] = this.defaultRXNCONSO;
    this.defaultmodelmap["RXNSAT"] = this.defaultRXNSAT;
    this.defaultmodelmap["PURCHASE_DELIVERY"] = this.defaultpurchasedelivery;
    this.defaultmodelmap["PURCHASE_ORDER"] = this.defaultpurchaseorder;
    this.defaultmodelmap["PURCHASE_INDEX"] = this.defaultpurchaseindex;
    this.defaultmodelmap["SUBSCRIBER"] = this.defaultsubscriber;
    this.defaultmodelmap["SUBSCRIBER_INDEX"] = this.defaultsubscriberindex;
    this.defaultmodelmap["SUPERBILL"] = this.defaultsuperbill;
    this.defaultmodelmap["SUPERBILL_INDEX"] = this.defaultsuperbillindex;
    this.defaultmodelmap["ACCOUNTING_SUMMARY"] = this.defaultaccountingsummary;
    this.defaultmodelmap["VIRAL_STAT"] = this.defaultviralstat;
    this.defaultmodelmap["ALERT_SUMMARY"] = this.defaultalertsummary;
    this.defaultmodelmap["CPT_CONTRAINDICATION"] = this.defaultcptcontraindication;
    this.defaultmodelmap["CPT_INTERACTION"] = this.defaultcptinteraction;
    this.defaultmodelmap["CPT_SYNONYM"] = this.defaultcptsynonym;
    this.defaultmodelmap["CPT_REQUIRED"] = this.defaultcptrequired;
    this.defaultmodelmap["NDC_CONTRAINDICATION"] = this.defaultndccontraindication;
    this.defaultmodelmap["NDC_INTERACTION"] = this.defaultndcinteraction;
    this.defaultmodelmap["NDC_SYNONYM"] = this.defaultndcsynonym;
    this.defaultmodelmap["NDC_REQUIRED"] = this.defaultndcrequired;
    this.defaultmodelmap["DIAG_CONTRAINDICATION"] = this.defaultdiagcontraindication;
    this.defaultmodelmap["DIAG_INTERACTION"] = this.defaultdiaginteraction;
    this.defaultmodelmap["DIAG_SYNONYM"] = this.defaultdiagsynonym;
    this.defaultmodelmap["DIAG_REQUIRED"] = this.defaultdiagrequired;
    this.defaultmodelmap["ALLERGY_INTERACTION"] = this.defaultallergyinteraction;
    this.defaultmodelmap["LIMITSUMMARY"] = this.defaultlimitsummary;
    this.defaultmodelmap["SURVEYSUMMARY"] = this.defaultsurveysummary;
    this.defaultmodelmap["RESULT"] = this.defaultresult;
    this.defaultmodelmap["GUIDELINE_SUMMARY"] = this.defaultguidelinesummary;
    this.defaultmodelmap["RESULT_INFORMATION"] = this.defaultresultinformation;
    this.defaultmodelmap["LIMITANDSURVEYRESULT"] = this.defaultlimitandsurveyresult;
    this.defaultmodelmap["CODERESULT"] = this.defaultcoderesult;
    this.defaultmodelmap["DEPENDENT_REFERENCE"] = this.defaultdependentreference;
    this.defaultmodelmap["COVERAGE"] = this.defaultcoverage;
    this.defaultmodelmap["BENEFIT_INFORMATION"] = this.defaultbenefitinformation;
    this.defaultmodelmap["REQUEST_VALIDATION"] = this.defaultrequestvalidation;
    this.defaultmodelmap["CLAIM_HEALTHCARE_DELIVERY"] = this.defaultclaimhealthcaredelivery;
    this.defaultmodelmap["REVIEWER"] = this.defaultreviewer;
    this.defaultmodelmap["LODGE_MEMBERSHIP_SUMMARY"] = this.defaultlodgemembershipsummary;
    this.defaultmodelmap["SENDERSOFTWARE"] = this.defaultss_sendersoftware;
    this.defaultmodelmap["HEADER"] = this.defaultss_header;
    this.defaultmodelmap["BODY"] = this.defaultss_body;
    this.defaultmodelmap["DIRECTORYMESSAGE"] = this.defaultss_directorymessage;
    this.defaultmodelmap["STATUS"] = this.defaultss_status;
    this.defaultmodelmap["ERROR"] = this.defaultss_error;
    this.defaultmodelmap["PURCHASE_ORDER_SERVICE"] = this.defaultpurchaseorderservice;
    this.defaultmodelmap["PAY_TO"] = this.defaultpayto;
    this.defaultmodelmap["PAY_TO_INDEX"] = this.defaultpaytoindex;
    this.defaultmodelmap["REPORT_SECTION"] = this.defaultrptsection;
    this.defaultmodelmap["REPORT_OBJECT"] = this.defaultrptobject;
    this.defaultmodelmap["MEDICATION_ACTIVITY"] = this.defaultmedicationactivity;
    this.defaultmodelmap["GENERAL_CODE"] = this.defaultgeneralcode;
    this.defaultmodelmap["PROVIDER_STAT"] = this.defaultproviderstat;
    this.defaultmodelmap["PHARMACY_STAT"] = this.defaultpharmacystat;
    this.defaultmodelmap["MEDICAL_SERVICE_INDEX"] = this.defaultmedicalserviceindex;
    this.defaultmodelmap["ACCOUNTING_PERIOD"] = this.defaultperiod;
    this.defaultmodelmap["ACCOUNTING_PERIOD_INDEX"] = this.defaultperiodindex;
    this.defaultmodelmap["EXTERNAL_DATA_REFERENCE"] = this.defaultexternaldatareference;
    this.defaultmodelmap["CLAIM"] = this.defaultclaim;
    this.defaultmodelmap["CLAIM_INDEX"] = this.defaultclaimindex;
    this.defaultmodelmap["CLAIM_BUCKET"] = this.defaultclaimbucket;
    this.defaultmodelmap["CLAIM_BUCKET_INDEX"] = this.defaultclaimbucketindex;
    this.defaultmodelmap["CLAIM_CONTRACT"] = this.defaultclaimcontract;
    this.defaultmodelmap["REFERRAL_REFERENCE"] = this.defaultreferralreference;
    this.defaultmodelmap["REFERRAL_INDEX"] = this.defaultreferralindex;
    this.defaultmodelmap["REFERRAL"] = this.defaultreferral;
    this.defaultmodelmap["CLAIM_HOME_HEALTH_CARE_PLAN"] = this.defaultclaimhealthcaredelivery;
    this.defaultmodelmap["CLAIM_MEDICARE_OUTPATIENT_ADJUDICATION"] = this.defaultclaimmedicareoutpatientadjudication;
    this.defaultmodelmap["CLAIM_NOTE"] = this.defaultclaimnote;
    this.defaultmodelmap["CLAIM_REPRICED"] = this.defaultclaimrepriced;
    this.defaultmodelmap["CLAIM_SPINAL"] = this.defaultclaimspinal;
    this.defaultmodelmap["CLAIM_SUPPLEMENTAL_INFORMATION"] = this.defaultclaimsupplementalinformation;
    this.defaultmodelmap["CLAIM_AMBULANCE"] = this.defaultclaimambulance;
    this.defaultmodelmap["CONDITION"] = this.defaultcondition;
    this.defaultmodelmap["AMOUNT"] = this.defaultamount;
    this.defaultmodelmap["SUBSCRIBER_REFERENCE"] = this.defaultsubscriberreference;
    this.defaultmodelmap["REFERRAL_REFERENCE"] = this.defaultreferralreference;
    this.defaultmodelmap["PREVIOUS_CERTIFICATION"] = this.defaultpreviouscertification;
    this.defaultmodelmap["RELATED_CAUSE"] = this.defaultrelatedcause;
    this.defaultmodelmap["ADDRESS_REFERENCE"] = this.defaultaddressreference;
    this.defaultmodelmap["OXYGEN_EQUIPMENT_TYPE"] = this.defaultoxygenequipmenttype;
    this.defaultmodelmap["PORTABLE_OXYGEN_EQUIPMENT_TYPE"] = this.defaultportableoxygenequipmenttype;
    this.defaultmodelmap["OXYGEN_TEST_RESULTS"] = this.defaultoxygentestresults;
    this.defaultmodelmap["BENEFITS_COORDINATION"] = this.defaultbenefitscoordination;
    this.defaultmodelmap["CPT_ADDON"] = this.defaultcptaddon;
    this.defaultmodelmap["NDC_ADDON"] = this.defaultndcaddon;
    this.defaultmodelmap["CPT_INCLUDES"] = this.defaultcptincludes;
    this.defaultmodelmap["NDC_INCLUDES"] = this.defaultndcincludes;
    this.defaultmodelmap["DIAG_INCLUDES"] = this.defaultdiagaddon;

    this.defaultmodelmap["CPT_EXCLUDES1"] = this.defaultcptexcludes1;
    this.defaultmodelmap["NDC_EXCLUDES1"] = this.defaultndcexcludes1;
    this.defaultmodelmap["DIAG_EXCLUDES1"] = this.defaultdiagexcludes1;

    this.defaultmodelmap["CPT_EXCLUDES2"] = this.defaultcptexcludes2;
    this.defaultmodelmap["NDC_EXCLUDES2"] = this.defaultndcexcludes2;
    this.defaultmodelmap["DIAG_EXCLUDES2"] = this.defaultdiagexcludes2;

    this.defaultmodelmap["CPT_NOTALLOWED"] = this.defaultcptnotallowed;
    this.defaultmodelmap["NDC_NOTALLOWED"] = this.defaultndcnotallowed;

    this.defaultmodelmap["CPT_ALLOWED"] = this.defaultcptallowed;
    this.defaultmodelmap["NDC_ALLOWED"] = this.defaultndcallowed;

    this.defaultmodelmap["CPT_NOTAPPLICABLE"] = this.defaultcptnotapplicable;
    this.defaultmodelmap["NDC_NOTAPPLICABLE"] = this.defaultndcnotapplicable;

    this.defaultmodelmap["CPT_MUEPOLICY2"] = this.defaultcptmuepolicy2;
    this.defaultmodelmap["NDC_MUEPOLICY2"] = this.defaultndcmuepolicy2;

    this.defaultmodelmap["CPT_MUECLINICAL3"] = this.defaultcptmueclinical3;
    this.defaultmodelmap["NDC_MUECLINICAL3"] = this.defaultndcmueclinical3;

    this.defaultmodelmap["CPT_CONSIDER"] = this.defaultcptconsider;
    this.defaultmodelmap["NDC_CONSIDER"] = this.defaultndcconsider;
    this.defaultmodelmap["DIAG_CONSIDER"] = this.defaultdiagconsider;

    this.defaultmodelmap["ENCOUNTER_STAT"] = this.defaultencounterstat;
    this.defaultmodelmap["APPOINTMENT_STAT"] = this.defaultappointmentstat;
    this.defaultmodelmap["CLINICAL_DAYSHEET_STAT"] = this.defaultclinicaldaysheetstat;
     
    this.defaultmodelmap["NOTEBOOK_ITEM"] = this.defaultnotebookitem;     
    this.defaultmodelmap["NBSS"] = this.defaultnotebookss;     
    this.defaultmodelmap["NOTEBOOK_PAGE"] = this.defaultnotebookpage;
    this.defaultmodelmap["NOTEBOOK_PAGE_INDEX"] = this.defaultnotebookpageindex;
    this.defaultmodelmap["NOTEBOOK_PAGE_TO_TYPE"] = this.defaultnotebookpagetotype;
  }


  public defaultpayer() { return new payer(); }
  public defaultassetjournal() { return new assetjournal(); }
  public defaultotheritemsjournal() { return new otheritemsjournal(); }
  public defaultgeneralledger() { return new generalledger(); }
  public defaultpayment() { return new payment(); }
  public defaultincomerevenuejournal() { return new incomerevenuejournal(); }
  public defaultservicepaymentreference() { return new servicepaymentreference(); }
  public defaultservicereference() { return new servicereference(); }
  public defaultliabilityjournal() { return new liabilityjournal(); }
  public defaultcapitalequityjournal() { return new capitalequityjournal(); }
  public defaultexpensejournal() { return new expensejournal(); }
  public defaulttaxrate() { return new taxrate(); }
  public defaulttaxauthority() { return new taxauthority(); }
  public defaulttaxrateauthority() { return new taxrateauthority(); }
  public defaulttoothinformation() { return new toothinformation(); }
  public defaulttestresults() { return new testresults(); }
  public defaultsuperbillchargesreference() { return new superbillchargesreference(); }
  public defaultsuperbillchargesindex() { return new superbillchargesindex(); }
  public defaultsuperbillcharges() { return new superbillcharges(); }
  public defaultmedicalservicereference() { return new medicalservicereference(); }
  public defaulthomeoxygen() { return new homeoxygen(); }
  public defaultreferenceimmunization() { return new referenceimmunization(); }
  public defaultimmunization() { return new immunization(); }
  public defaultformidentification() { return new formidentification(); }
  public defaultformdocumentation() { return new formdocumentation(); }
  public defaultfileinformation() { return new fileinformation(); }
  public defaultdmerc() { return new dmerc(); }
  public defaultdental() { return new dental(); }
  public defaultanesthesia() { return new anesthesia(); }
  public defaultadjudicationdetail() { return new adjudicationdetail(); }
  public defaultadjudication() { return new adjudication(); }
  public defaultservicedate() { return new servicedate(); }
  public defaultreferenceidentification() { return new referenceidentification(); }
  public defaultmedicalservice() { return new medicalservice(); }
  public defaultlicense() { return new licenseobject(); }
  public defaultfee() { return new feeobject(); }
  public defaultlimit() { return new limitobject(); }
  public defaultsubscription() { return new subscriptionobject(); }
  public defaultorder() { return new orderobject(); }
  public defaultorderdetail() { return new orderdetailobject(); }
  public defaultpaymentrequest() { return new paymentrequest(); }
  public defaultotheritemsreceiving() { return new otheritemsreceiving(); }
  public defaultotheritemsindex() { return new otheritemsindex(); }
  public defaultotheritems() { return new otheritems(); }
  public defaultencounterprogressnotes() { return new encounterprogressnotes(); }
  public defaultencounterprogressnotesreference() { return new encounterprogressnotesreference(); }
  public defaultDrugsResponse() { return new DrugsResponse(); }
  public defaultDrugsSideEffectsResponse() { return new DrugsSideEffectsResponse(); }
  public defaultDrugIngredientsResponse() { return new DrugIngredientsResponse(); }
  public defaultDrugSideEffect() { return new DrugSideEffect(); }
  public defaultDrugIngredient() { return new DrugIngredient();}
  public defaultDrugComposition() { return new DrugComposition(); }
  public defaultDrug() { return new Drug(); }
  public defaultRXNCONSO() { return new RXNCONSO(); }
  public defaultRXNSAT() { return new RXNSAT(); }
  public defaultpurchasedelivery() { return new purchasedelivery(); }
  public defaultpurchaseorder() { return new purchaseorder(); }
  public defaultpurchaseindex() { return new purchaseindex(); }
  public defaultpurchaseorderservice() { return new purchaseorderservice(); }
  public defaultpayto() { return new payto(); }
  public defaultpaytoindex() { return new paytoindex(); }
  public defaultsubscriber() { return new subscriber(); }
  public defaultsubscriberindex() { return new subscriberindex(); }
  public defaultsuperbill() { return new superbill(); }
  public defaultsuperbillindex() { return new superbillindex(); }
  public defaultaccountingsummary() { return new accountingsummary(); }
  public defaultviralstat() { return new viralstat(); }
  public defaultalertsummary() { return new alertsummary(); }
  public defaultcptcontraindication() { return new cpt_contraindication(); }
  public defaultcptinteraction() { return new cpt_interaction(); }
  public defaultcptsynonym() { return new cpt_synonym(); }
  public defaultcptrequired() { return new cpt_required(); }
  public defaultndccontraindication() { return new ndc_contraindication(); }
  public defaultndcinteraction() { return new ndc_interaction(); }
  public defaultndcsynonym() { return new ndc_synonym(); }
  public defaultndcrequired() { return new ndc_required(); }
  public defaultdiagcontraindication() { return new diag_contraindication(); }
  public defaultdiaginteraction() { return new diag_interaction(); }
  public defaultdiagsynonym() { return new diag_synonym(); }
  public defaultdiagrequired() { return new diag_required(); }
  public defaultcptaddon() { return new cpt_addon(); }
  public defaultndcaddon() { return new ndc_addon(); }

  public defaultcptincludes() { return new cpt_includes(); }
  public defaultndcincludes() { return new ndc_includes(); }
  public defaultdiagaddon() { return new diag_includes(); }

  public defaultcptexcludes1() { return new cpt_excludes1(); }
  public defaultndcexcludes1() { return new ndc_excludes1(); }
  public defaultdiagexcludes1() { return new diag_excludes1(); }

  public defaultcptexcludes2() { return new cpt_excludes2(); }
  public defaultndcexcludes2() { return new ndc_excludes2(); }
  public defaultdiagexcludes2() { return new diag_excludes2(); }

  public defaultcptnotallowed() { return new cpt_notallowed(); }
  public defaultndcnotallowed() { return new ndc_notallowed(); }

  public defaultcptallowed() { return new cpt_allowed(); }
  public defaultndcallowed() { return new ndc_allowed(); }

  public defaultcptnotapplicable() { return new cpt_notapplicable(); }
  public defaultndcnotapplicable() { return new ndc_notapplicable(); }

  public defaultcptmuepolicy2() { return new cpt_muepolicy2(); }
  public defaultndcmuepolicy2() { return new ndc_muepolicy2(); }

  public defaultcptmueclinical3() { return new cpt_mueclinical3(); }
  public defaultndcmueclinical3() { return new ndc_mueclinical3(); }

  public defaultcptconsider() { return new cpt_consider(); }
  public defaultndcconsider() { return new ndc_consider(); }
  public defaultdiagconsider() { return new diag_consider(); }

  public defaultallergyinteraction() { return new allergy_interaction(); }
  public defaultlimitsummary() { return new limitsummary(); }
  public defaultsurveysummary() { return new surveysummary(); }
  public defaultresult() { return new resultsummary(); }
  public defaultguidelinesummary() { return new guidelinesummary(); }
  public defaultresultinformation() { return new resultinformation(); }
  public defaultlimitandsurveyresult() { return new limitandsurveyresult(); }
  public defaultcoderesult() { return new coderesult(); }
  public defaultdependentreference() { return new dependentreference(); }
  public defaultcoverage() { return new coverage(); }
  public defaultbenefitinformation() { return new benefitinformation(); }
  public defaultrequestvalidation() { return new requestvalidation(); }
  public defaultclaimhealthcaredelivery() { return new claimhealthcaredelivery(); }
  public defaultreviewer() { return new reviewer(); }
  public defaultlodgemembershipsummary() { return new lodgemembershipsummary(); }
  public defaultss_sendersoftware() { return new SS.ss_sendersoftware(); }
  public defaultss_header() { return new SS.ss_header(); }
  public defaultss_body() { return new SS.ss_body(); }
  public defaultss_directorymessage() { return new SS.ss_message("DirectoryMessage"); }
  public defaultss_status() { return new SS.ss_status("Status"); }
  public defaultss_error() { return new SS.ss_status("Error"); }
  public defaultrptsection() { return new rptsection(); }
  public defaultrptobject() { return new rptobject(); }
  public defaultmedicationactivity() { return new medicationactivity(); }
  public defaultgeneralcode() { return new basecode("GENERAL_CODE"); }
  public defaultproviderstat() { return new providerstat(); }
  public defaultpharmacystat() { return new pharmacystat(); }
  public defaultmedicalserviceindex() { return new medicalserviceindex(); }
  public defaultperiod() { return new accountingperiod(); }
  public defaultperiodindex() { return new accountingperiodindex(); }
  public defaultexternaldatareference() { return new externaldatareference(); }
  public defaultclaim() { return new claim(); }
  public defaultclaimindex() { return new claimindex(); }
  public defaultclaimbucket() { return new claimbucket(); }
  public defaultclaimbucketindex() { return new claimbucketindex(); }
  public defaultclaimcontract() { return new claimcontract(); }
  public defaultclaimhomehealthcareplan() { return new claimhomehealthcareplan(); }
  public defaultclaimmedicareoutpatientadjudication() { return new claimmedicareoutpatientadjudication(); }
  public defaultclaimnote() { return new claimnote(); }
  public defaultclaimrepriced() { return new claimrepriced(); }
  public defaultclaimspinal() { return new claimspinal(); }
  public defaultclaimsupplementalinformation() { return new claimsupplementalinformation(); }
  public defaultclaimambulance() { return new claimambulance(); }
  public defaultcondition() { return new condition(); }
  public defaultamount() { return new amount(); }
  public defaultsubscriberreference() { return new subscriberreference(); }
  public defaultreferralreference() { return new referralreference(); }
  public defaultreferralindex() { return new referralindex(); }
  public defaultreferral() { return new referral(); }
  public defaultpreviouscertification() { return new previouscertification(); }
  public defaultrelatedcause() { return new relatedcause(); }
  public defaultaddressreference() { return new addressreference(); }
  public defaultoxygenequipmenttype() { return new oxygenequipmenttype("OXYGEN_EQUIPMENT_TYPE"); }
  public defaultportableoxygenequipmenttype() { return new oxygenequipmenttype("PORTABLE_OXYGEN_EQUIPMENT_TYPE"); }
  public defaultoxygentestresults() { return new oxygentestresults(); }
  public defaultbenefitscoordination() { return new benefitscoordination(); }
  public defaultencounterstat() { return new encounterstat(); }
  public defaultappointmentstat() { return new appointmentstat(); }
  public defaultclinicaldaysheetstat() { return new clinicaldaysheetstat(); }
  public defaultnotebookitem() { return new notebookitem(); }
  public defaultnotebookss() { return new notebookss(); }
  public defaultnotebookpage() { return new notebookpage(); }
  public defaultnotebookpageindex() { return new notebookpageindex(); }
  public defaultnotebookpagetotype() { return new notebookpagetotype(); }

    //////////////////////
    // Public functions //
    //////////////////////
    
  public geticexdocumentobjects(xmdocdata: string, listOfTables: string[]): any {
    if (xmdocdata == null || xmdocdata == "")
      return null;

    if (Iceutility.isobject(xmdocdata)) {
      var ret = null;
      try {
          ret = this.geticexobjects(xmdocdata, listOfTables, null);
      }
      catch (e) {
          console.log(e);
      }
      if (ret == null) ret = xmdocdata;
      return ret;
    }

    let endelement = "</ICEXDocument>";
    let beginelement = "<ICEXDocument";
    let pos1 = xmdocdata.indexOf(beginelement);
    let pos2 = xmdocdata.indexOf(endelement);

    let decode: boolean = false;
    if (pos1 < 0) {
      endelement = "&amp;lt;/ICEXDocument&amp;gt;";
      beginelement = "&amp;lt;ICEXDocument";
      pos1 = xmdocdata.indexOf(beginelement);
      pos2 = xmdocdata.indexOf(endelement);
      decode = true;
    }

    if (pos1 < 0) { // try again
      endelement = "&lt;/ICEXDocument";
      beginelement = "&lt;ICEXDocument";
      pos1 = xmdocdata.indexOf(beginelement);
      pos2 = xmdocdata.indexOf(endelement);
      decode = true;
    }

    if (pos1 < 0) return null;
    if (pos2 < 0) return null;

    xmdocdata = xmdocdata.substring(pos1, pos2 + endelement.length);

    try {
      let parser = new DOMParser();

      if (decode) {
          xmdocdata = xmdocdata.replace(/&amp;/g, '&');
          xmdocdata = xmdocdata.replace(/&lt;/g, '<');
          xmdocdata = xmdocdata.replace(/&gt;/g, '>');
          xmdocdata = xmdocdata.replace(/&quot;/g, '\\"');
          xmdocdata = xmdocdata.replace(/&nbsp;/g, ' ');
      }

      let xmlDoc = parser.parseFromString(xmdocdata, "text/xml");
      if (xmlDoc != null)
          return this.geticexobjects(xmlDoc, listOfTables, null);
    }
    catch (e) {
      console.log(e);
    }
    return null;
  }

  getsubtreedata(Ary: any[], ColumnName: string, Value: any) {
    if (Ary == null || Ary.length == 0)
      return null;

    if (ColumnName == null || ColumnName.length == 0)
      return null;

    if (Value == null || Value.length == 0)
      return null;

    var obj = null;
    for (var i = 0; i < Ary.length; i++) {
      var tmp = Ary[i];
      if (tmp == null)
        continue;

      var tmpval = tmp[ColumnName.toLowerCase()];
      if (tmpval != null && tmpval.toLowerCase() == Value.toLowerCase()) {
        obj = tmp;
        break;
      }
    }
    return obj;
  }

    public getXHResponse(jqXHR) {
        if (jqXHR == null)
            return "";

        var res = "";
        if (!Iceutility.isdefined(jqXHR.responseText) || jqXHR.responseText.length == 0) {
            if (jqXHR["body"] != null) {
                res = jqXHR.body.innerHTML;
            }
            else if (jqXHR.children != null && jqXHR.children.length > 0) {
                res = this.decodeXml(jqXHR.children[0].innerHTML);
            }
        }
        else {
            res = jqXHR.responseText;
        }
        return res;
    }

    public parseLogReport(url: string, data: any) {
        this.setLastRequest(url);
        this.setLastLogReport(null);
        this.setLastGenericError(null);

        if (data == null) return data;

        let results: any = this.geticexdocumentobjects(Iceutility.isdefined(data.error) ? data.error : data, ["LogReport"]);
        if (results && Array.isArray(results) && results[0] instanceof LogReport) {
          this.setLastLogReport(results);
          this.alertService.logger(results[0]);
        }
        else this.setLastGenericError(results);

      if (Iceutility.isdefined(data["status"]) && Iceutility.toLong(data["status"]) == 401) {
        this.loginService.ServiceLogin();
      }
      return data;
    }

    public logMessage(logType: IceTypes.LOGTYPE, msg: string): void {
      try {
        let logmsg: logmessage = new logmessage();
        logmsg.date = Iceutility.GetLocalDate();
        logmsg.logtype = logType;
        logmsg.message = msg;
        let logrpt: LogReport = new LogReport(logmsg);
        this.alertService.logger(logrpt);
      }
      catch (e) {
        console.log(e);
      }
    }

    private createicexdocumentobject(table: string): any {
        if (table == null || table.length == 0)
            return null;

        let obj = null;
        try {

            let tbln = table.toUpperCase();
            switch (tbln) {
                case "PROVIDER_INDEX":
                    {
                        obj = new provider_index();
                        break;
                    }
                case "PROVIDER_REFERENCE":
                    {
                      obj = new provider_reference(null);
                      break;
                    }
                case "PAYER_INDEX":
                    {
                        obj = new payer_index();
                        break;
                    }
                case "PATIENT":
                    {
                        obj = new patient();
                        break;
                    }
                case "PATIENT_INDEX":
                    {
                        obj = new patientindex();
                        break;
                    }
                case "CONTACT":
                    {
                        obj = new contact();
                        break;
                    }
                case "ENTITY":
                    {
                        obj = new entity();
                        break;
                    }
                case "ADDRESS":
                    {
                        obj = new address();
                        break;
                    }
                case "IDENTIFICATION":
                    {
                        obj = new identification();
                        break;
                    }
                case "PROVIDER":
                case "FACILITY":
                    {
                        obj = new provider(tbln);
                        break;
                    }
                case "PHARMACY":
                    {
                        obj = new pharmacy();
                        break;
                    }
                case "PHARMACY_INDEX":
                    {
                        obj = new pharmacyindex();
                        break;
                    }
                case "LOG_MESSAGE":
                    {
                        obj = new logmessage();
                        break;
                    }
                case "LOGREPORT":
                    {
                        obj = new LogReport();
                        break;
                    }
                case "MESSAGE":
                    {
                        obj = new message();
                        break;
                    }
                case "ALERT":
                    {
                        obj = new alert();
                        break;
                    }
                case "MESSAGE_REFERENCE":
                    {
                        obj = new messagereference();
                        break;
                    }
                case "CALENDAR":
                    {
                        obj = new calendar();
                        break;
                    }
                case "APPOINTMENT":
                    { obj = new appointment(); break; }
                case "APPOINTMENT_INDEX":
                    { obj = new appointmentindex(); break; }
                case "APPOINTMENT_REFERENCE":
                    { obj = new appointmentreference(); break; }
                case "DAY":
                    { obj = new day(); break; }
                case "SLOT":
                    { obj = new slot(); break; }
                case "TASK":
                    { obj = new task(); break; }
                case "TASK_INDEX":
                    { obj = new taskindex(); break; }
                case "TASK_REFERENCE":
                    { obj = new taskreference(); break; }
                case "REPORT":
                    { obj = new report(); break; }
                case "REPORT_INDEX":
                    { obj = new reportindex(); break; }
                case "REPORT_TEMPLATE":
                  { obj = new reporttemplate(); break; }
                case "REPORT_FILTER":
                  { obj = new reportfilter(); break; }
                case "REPORT_DATA":
                  { obj = new reportdata(); break; }
                case "ANTENATAL_ATTENDANCE_STAT":
                  { obj = new antenatalattendancestat(); break; }
                case "LABOR_DELIVERY_STAT":
                  { obj = new labordeliverystat(); break; }
                case "PATIENT_STAT":
                  { obj = new patientstat(); break; }
                case "DIAGNOSIS":
                  { obj = new diagnosis(); break; }
                case "MEDICATION":
                  { obj = new medication(); break; }
                case "ALLERGIES":
                  { obj = new allergies(); break; }
                case "ATTACHMENTS":
                case "EXTERNAL_DATA":
                  { obj = new externaldata(); break; }
                case "ORDER_ENTRY_INDEX":
                  { obj = new orderentryindex(); break; }
              
                case "USER":
                case "USER_TRANS_ACCOUNT":
                  { obj = new user(); break; }
                case "CONSENT_REFERENCE":
                  { obj = new consentreference(); break; }
                case "CONNECTION_PARAMETERS":
                  { obj = new connectionparameters(); break; }
                case "OBSERVATION":
                  { obj = new observation(); break; }
                case "SUB_TYPE_REFERENCE":
                  { obj = new subtypereference(); break; }
                case "BASE_CODE_REFERENCE":
                  { obj = new basecodereference(); break; }
                case "MANAGEMENT_GUIDELINE":
                  { obj = new managementguideline(); break; }
                case "MANAGEMENT_GUIDELINE_INDEX":
                  { obj = new managementguidelineindex(); break; }
                case "PROCEDURE":
                  { obj = new procedure(); break; }
                case "DIAGNOSIS_REFERENCE":
                  { obj = new diagnosisreference(); break; }
                case "ENCOUNTER_INDEX":
                  { obj = new encounterindex(); break; }
                case "SUBTYPE_ITEM":
                  { obj = new subtypeitem(); break; }
                case "PAYER_PROVIDER_REFERENCE_IDENTIFICATION":
                  { obj = new payerproviderreferenceidentification(); break; }
                case "VENDOR":
                  { obj = new vendor(); break; }
                case "VENDOR_INDEX":
                  { obj = new vendorindex(); break; }
                case "CONNECTION_PARAMETERS":
                  { obj = new connectionparameters(); break; }
                case "TRANS_TYPE":
                  { obj = new transtype(); break; }                
                case "TRANS_TYPE_REFERENCE":
                  { obj = new transtypereference(); break; }
                case "ENCOUNTER":
                  { obj = new encounter(); break; }
                case "ENCOUNTER_INDEX":
                  { obj = new encounterindex(); break; }
                case "OPTION":
                  { obj = new option(); break; }
                case "PROVIDER_CODE":
                case "NDCCODE":
                case "BENEFIT_CODE":
                case "PAYER_RESPONSIBILITY_SEQUENCE_NUMBER":
                case "INDIVIDUAL_RELATIONSHIP_CODE":
                case "INSURANCE_TYPE":
                case "CLAIM_FILING_INDICATOR_CODE":
                case "FACILITY_TYPE_CODE":
                case "RELEASE_OF_INFORMATION_CODE":
                case "DATETIME_QUALIFIER":
                case "SERVICE_TYPE_CODE":
                case "AMBULANCE_TRANSPORT_REASON_CODE":
                case "SERVICE_LEVEL":
                case "IDENTIFICATION_CODE_QUALIFIER":
                case "FORMULARYCODE":
                case "QUANTITYUNITOFMEASURE":
                case "DEASCHEDULE":
                case "MEASUREMENTUNITCODE":
                case "STRENGTHFORM":
                case "STRENGTHUNITOFMEASURE":
                case "CPTCODE":
                case "NDCCODE_ALTERNATIVES":
                case "NDCCODE_IDENTICAL":
                case "NDCCODE_PREFERENCES":
                case "NDCCODE_INTERACTIONS":
                case "NDCCODE_INFORMATION":
                case "ICDCODE":
                case "DIAGNOSIS_TYPE_CODE":
                case "SideEffects":
                case "MOOD_CODE":
                case "FAVORITECODE":
                case "COMMUNICATION_NUMBER_QUALIFIER":
                case "STATE":
                case "COUNTRY":
                case "CURRENCY":
                case "CLINICAL_CODE":
                case "TAXONOMY":
                case "FEATURE_DETAIL":
                case "SUBTYPE_ITEM_HIERARCHY":
                case "DRUGCOMPOSITION":
                case "SIDEEFFECT":
                case "INGREDIENT":
                case "MODIFIER_CODE":
                case "DATETIME_CODE":
                {
                    switch (tbln) {
                      case "NDCCODE_ALTERNATIVES":
                      case "NDCCODE_IDENTICAL":
                      case "NDCCODE_PREFERENCES":
                      case "NDCCODE_INTERACTIONS":
                      case "SideEffects":
                        {
                          tbln = "NDCCODE";
                          break;
                        }
                    }

                    obj = new basecode(tbln);
                    break;
                  }
              default:
                {
                  if (Iceutility.isdefined(this.defaultmodelmap[tbln])
                    && Iceutility.isfunction(this.defaultmodelmap[tbln])) {
                    obj = this.defaultmodelmap[tbln]();
                    break;
                  }

                    throw "Table: " + tbln + " Not supported.";
                }
            }
        }
        catch (err) {
            console.log(err);
        }
        return obj;
    }

    ///////////////////////
    // Private functions //
    ///////////////////////

    private decodeXml(string) {
        return string.replace(/(&quot;|&lt;|&gt;|&amp;)/g,
            function (str, item) {
                return this.escaped_one_to_xml_special_map[item];
            });
    }

    private geticexobjects(iceXDoc: any, listOfTables: string[], icexobjs: any): any {
        if (iceXDoc == null)
            return null;

        let nodes: any = iceXDoc.childNodes;

        if (listOfTables == null || listOfTables.length == 0) {
            if (nodes != null && nodes.length > 0) {
                var nd = nodes[0];
                if (nd != null) {
                    var type = nd.getAttribute('Type');
                    if (type.toLowerCase() == "application/json") {
                        var jsondata = null
                        try {
                            var data = nd.textContent;
                            jsondata = JSON.parse(data);
                        }
                        catch (e) {
                            jsondata = null;
                        }
                        return jsondata;
                    }
                }
            }
        }

        try {
            if (nodes != null) {
                for (let i = 0; i < nodes.length; i++) {
                    let nd = nodes[i];
                    let nodename = nd.nodeName.toUpperCase();
                    switch (nodename) {
                        case "ICEXDOCUMENT":
                        case "INFO":
                            {
                                icexobjs = this.geticexobjects(nd, listOfTables, icexobjs);
                                break;
                            }
                        default:
                            {
                                if ((listOfTables == null || listOfTables.length == 0) || Iceutility.existinarray(listOfTables, nodename)) {

                                    let obj = this.createicexdocumentobject(nodename);
                                    if (obj != null) {
                                        if (nd.attributes) {
                                          for (let iattr = 0; iattr < nd.attributes.length; iattr++) {
                                            let attr = nd.attributes[iattr];
                                            if (attr == null) continue;

                                            if (obj.attributes == null)
                                              obj.attributes = {};

                                            obj.attributes[attr.name] = attr.value;
                                          }
                                        }

                                        let subfuncdefined = Iceutility.isfunction(obj.hassubtree) && Iceutility.isfunction(obj.getsubtreetablename);
                                        let elem = nd.firstChild;
                                        if (elem != null) {
                                            do {
                                                if (elem.nodeType == 1) {
                                                  let name = elem.nodeName;
                                                  if (subfuncdefined && obj.hassubtree(name)) {
                                                    let tblsToProcess: string[] = obj.getsubtreetablename(name).split(",");
                                                    let subobj = obj[name];
                                                    if (subobj != null && Array.isArray(subobj)) {
                                                      let newobj = this.geticexobjects(elem, tblsToProcess, null);
                                                      if (newobj == null)
                                                        newobj = this.createicexdocumentobject(name);

                                                      if (newobj != null && Array.isArray(newobj)) {
                                                        subobj = subobj.concat(newobj);
                                                      }
                                                      else {
                                                        subobj.push(newobj);
                                                      }
                                                      obj[name] = subobj;
                                                    }
                                                    else {
                                                      obj[name] = this.geticexobjects(nd, tblsToProcess, null);
                                                    }

                                                    if (obj[name] == null) {
                                                      obj[name] = this.createicexdocumentobject(name);
                                                    }
                                                    if (obj[name] != null) {
                                                      if (obj[name].hasinnerdata == true)
                                                        obj[name].innerdata = elem.textContent;

                                                      for (let iattr = 0; iattr < elem.attributes.length; iattr++) {
                                                        let attr = elem.attributes[iattr];
                                                        if (attr == null) continue;

                                                        if (obj[name].attributes == null)
                                                          obj[name].attributes = {};

                                                        obj[name].attributes[attr.name] = attr.value;
                                                      }
                                                    }
                                                  }
                                                  else {
                                                    var text = elem.textContent;
                                                    obj[name.toLowerCase()] = text;
                                                  }
                                                }
                                                else if (elem.nodeType == 3) {
                                                    let text = elem.textContent;
                                                    obj[elem.parentElement.nodeName.toLowerCase()] = text;
                                                }
                                                elem = elem.nextSibling;
                                            } while (elem != null);
                                        }

                                        if (icexobjs == null)
                                            icexobjs = new Array();

                                        icexobjs.push(obj);
                                    }
                                }
                                break;
                            }
                    }
                }
            }
        }
        catch (err) {
            console.log(err);
        }
        return icexobjs;
    }
}
